// non angular vendor libraries used by the PWS.
import 'picturefill'
import 'lazysizes'
import AOS from 'aos'

// All the angular modules required by the main website.
import 'angular'
import 'angular-route';
import 'angular-cookies' // NgCookies module
import 'angular-touch' // NgTouch module
import 'angular-sanitize' // NgSanitize module
import 'angular-messages' // NgMessages module
import 'angular-placeholder' // NgPlacholder module
import 'angular-socialshare' // '720kb.socialshare' module
import 'angular-scroll' // DuScroll module
import 'angular-filter' // Angular.filter module
import 'angularjs-slider' // RzModule module
import 'ng-infinite-scroll' // Infinite-scroll module

// Initilaise the animate on scroll library.
AOS.init()
